// Full-document render of the stearns HomePage: PageSkeleton (the React
// document shell) wrapping the existing home-page body island (which reproduces
// the per-block block-{type} wrappers the home-page SCSS targets). The legacy
// template rendered the body inside <main> with the site header/footer intact;
// the "home-page" body_class and WebPage-only JSON-LD are carried in
// page_chrome.
import React from "react";

import { templates } from "@reactivated";

import { HomePageBody } from "../components/HomePageBody";
import { PageSkeleton } from "../components/PageSkeleton";

// Mutable reactivated props (not Immutable<>): this template composes the
// in-tree SiteHeader/RichNavigation chain via PageSkeleton, which is typed with
// mutable reactivated props. The body template accepts Immutable props, to which
// these are assignable.
export const Template = (
    props: templates.HomePageTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <HomePageBody page={props.page} />
    </PageSkeleton>
);
